// Helpers téléphone partagés entre MonCompte (édition profil) et SlotPicker
// (capture en réservation). Purs — testables sans DOM.
//
// `import type` n'émet aucun octet : dépendre de `MsgKey` ne tire pas le
// catalogue dans le bundle de ce module.
import type { MsgKey } from '../i18n/types'

export const COUNTRIES = [
  { code: 'FR', flag: '🇫🇷', name: 'France',        dial: '33' },
  { code: 'BE', flag: '🇧🇪', name: 'Belgique',      dial: '32' },
  { code: 'CH', flag: '🇨🇭', name: 'Suisse',        dial: '41' },
  { code: 'LU', flag: '🇱🇺', name: 'Luxembourg',    dial: '352' },
  { code: 'MC', flag: '🇲🇨', name: 'Monaco',        dial: '377' },
  { code: 'GB', flag: '🇬🇧', name: 'Royaume-Uni',   dial: '44' },
  { code: 'DE', flag: '🇩🇪', name: 'Allemagne',     dial: '49' },
  { code: 'ES', flag: '🇪🇸', name: 'Espagne',       dial: '34' },
  { code: 'IT', flag: '🇮🇹', name: 'Italie',        dial: '39' },
  { code: 'NL', flag: '🇳🇱', name: 'Pays-Bas',      dial: '31' },
  { code: 'US', flag: '🇺🇸', name: 'États-Unis',    dial: '1' },
] as const

/** Découpe un E.164 stocké en indicatif + numéro local (défaut FR/33). */
export function parseStoredPhone(stored: string): { dialCode: string; localNumber: string } {
  if (!stored || !stored.startsWith('+')) return { dialCode: '33', localNumber: '' }
  const digits = stored.slice(1)
  const sorted = [...COUNTRIES].sort((a, b) => b.dial.length - a.dial.length)
  for (const c of sorted) {
    if (digits.startsWith(c.dial)) return { dialCode: c.dial, localNumber: digits.slice(c.dial.length) }
  }
  return { dialCode: '33', localNumber: digits }
}

/** Reconstruit un E.164 depuis indicatif + numéro local. null si vide. */
export function formatE164(dialCode: string, localNumber: string): string | null {
  const digits = localNumber.replace(/\D/g, '').replace(/^0+/, '')
  return digits ? `+${dialCode}${digits}` : null
}

/**
 * Clé d'erreur si le numéro local est présent mais trop court. `null` = OK, le
 * champ étant facultatif.
 *
 * Rend une CLÉ et non un libellé (Phase 97, plan 97-07). Le libellé français
 * était cousu ici, et ses DEUX appelants — `/mon-compte` et le SlotPicker de
 * `/reserve/:duration_hours` — rendent des pages traduites : il se serait donc
 * rendu tel quel en anglais. Aucun scan ne l'attrapait, ni celui de la Phase 96
 * (par fichier, et le fichier fautif n'est pas la page) ni le harnais D-04 (le
 * champ est vide à l'état par défaut, l'erreur n'existe pas). C'est le SEUIL
 * qui vit ici ; la phrase vit au catalogue.
 */
export function validateLocalNumber(num: string): MsgKey | null {
  if (!num) return null
  if (num.length < 7) return 'phone.tooShort'
  return null
}
